module.exports = __webpack_public_path__ + "img/general.28624a40.png";